import { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { fetchAnimeDetail } from '../../features/anime/animeSlice';
import { Box, Card, CardMedia,  LinearProgress, Paper, Typography, useMediaQuery, useTheme } from '@mui/material';

export default function AnimeDetail() {
  const { id } = useParams<{ id: string }>();
  const dispatch = useAppDispatch();
  const { detail, detailLoading, detailError } = useAppSelector((s) => s.anime);
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  useEffect(() => {
    if (id) dispatch(fetchAnimeDetail(id));
  }, [id, dispatch]);

  if (detailLoading)
  return (
    <LinearProgress
      sx={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '75%', // 3/4 screen
      }}
    />
  );
  if (detailError) return <Typography color="error">{detailError}</Typography>;
  if (!detail) return null;

  return (
  <>
    {/* identical title to search page */}
    
    <Box sx={{ m: 3, textAlign: 'center' }}>
      <Typography
        variant="h3"
        component={Link}
        to="/"
        sx={{
          fontWeight: 'bold',
          textDecoration: 'none',
          color: 'inherit',
          '&:hover': { opacity: 0.8 },
        }}
      >
        <Box component="span" sx={{ color: 'success.main' }}>Ani</Box>Search
      </Typography>
    </Box>

    {/* centred detail card */}
    <Box sx={{ display: 'grid', placeItems: 'center', minHeight: '70vh', m:3 }}>
      {detailLoading && (
        <LinearProgress
          sx={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '90%', sm: '80%', md: '75%' },
          }}
        />
      )}

      {detailError && <Typography color="error">{detailError}</Typography>}
      {!detail && !detailLoading && <Typography>No detail found.</Typography>}

      {detail && (
  <Paper elevation={7} sx={{ borderRadius: 4, overflow: 'hidden', maxWidth: 1200, width: '100%' }}>
    <Card sx={{ position: 'relative', display: 'flex', gap: 1, flexDirection: { xs: 'column', md: 'row' } }}>
      {/* poster */}
      <CardMedia
        component="img"
        image={detail.images.webp.image_url}
        alt={detail.title}
        sx={{
          width: { xs: '100%', md: 360 },
          aspectRatio: '7/10',
          objectFit: 'cover',
          borderRadius: 0,
        }}
      />

      {/* info overlay */}
      <Box flex={1} p={3} display="flex" flexDirection="column" justifyContent="space-between">
        <Box>
          <Typography variant={isDesktop ? 'h3' : 'h4'} gutterBottom>{detail.title}</Typography>
          <Box
          sx={{
                mb: 3,
                px: 1.5,
                py: 0.5,
                borderRadius: 4,
                backgroundColor: 'primary.main',
                color: 'primary.contrastText',
                fontSize: '0.875rem',
                lineHeight: '20px',
                height: 32,
                display: 'inline-flex',
                alignItems: 'center',
              }}
        >
          <Typography variant="body2">Score: {detail.score}</Typography>
        </Box>
          <Typography variant="body1" textAlign="justify" lineHeight={1.7}>
            {detail.synopsis}
          </Typography>
        </Box>

        {/* gradient strip at bottom */}
        
      </Box>
    </Card>
  </Paper>
)}
    </Box>
  </>
);;
}